// #1750 / equitation-class-sheet-design.md §11 -- a judge-percentage sheet
// (the class-grid layout) has no movement math to derive a total from: the
// Total cell IS the score of record, typed directly by the scribe. Every
// other scoring model keeps percentage server-computed-only. Never widen
// this beyond the one model, and never drop the guard for anyone else.
//
// Pulled out to its own module (#3008 judge round 1) so BOTH the save path
// (useScoreSheet.js's toBody()) and the stale_write auto-merge path
// (sync.js -> threeWayMerge.js) import this SAME predicate instead of
// useScoreSheet.js defining it and sync.js re-deriving a second copy --
// "which sheets own their own percentage" must never be able to drift
// between the two. useScoreSheet.js previously defined this locally; moving
// it here (rather than sync.js importing straight from useScoreSheet.js)
// avoids introducing a sync.js <-> useScoreSheet.js import cycle (sync.js
// already exports `syncEngine`, which useScoreSheet.js imports).
export const CLIENT_WRITABLE_TOTAL_SCORING_MODEL = "judge-percentage";

export function scoreSheetIsClientTotal(test) {
  return test?.scoringModel === CLIENT_WRITABLE_TOTAL_SCORING_MODEL;
}
